import { API_ENDPOINTS } from '@/constants';
import { apiRequest } from '@/services/client';

export const logout = async () => {
  await apiRequest<void>(API_ENDPOINTS.AUTH.LOGOUT, {
    method: 'POST',
    retry: { retries: 0 },
  });
};
